/** Contact-era statuses that become QUALIFIED when converting to a sales op. */
export const CONTACT_ERA_STATUSES_FOR_CONVERT = new Set([
  'NEW',
  'NEEDS_FOLLOWUP',
  'INFO_SENT',
  'CALL_1',
  'CALL_2',
  'CALL_3',
  'OPEN',
  '',
]);

export const SALES_BOARD_STATUSES = [
  'QUALIFIED',
  'NEEDS_FOLLOWUP',
  'INFO_SENT',
  'FINANCE_APPLICATION',
  'READY_TO_CLOSE',
  'BOOKED',
  'CLOSED',
] as const;

/** Statuses that auto-move to INFO_SENT after sending a quote. */
export const QUOTE_AUTO_INFO_SENT_STATUSES = new Set([
  'QUALIFIED',
  'NEEDS_FOLLOWUP',
  'CALL_1',
  'CALL_2',
  'CALL_3',
]);

export function isSalesOpportunity(lead: {
  sales_opportunity_at?: string | null;
}): boolean {
  return Boolean(lead?.sales_opportunity_at);
}

export function statusAfterConvertToSalesOp(
  currentStatus: string | null | undefined,
): string {
  const status = currentStatus ?? 'NEW';
  if (
    status === 'FINANCE_APPLICATION' ||
    status === 'READY_TO_CLOSE' ||
    status === 'BOOKED' ||
    status === 'CLOSED' ||
    status === 'QUALIFIED'
  ) {
    return status;
  }
  return 'QUALIFIED';
}
